export const tag_list_jp = [
  '1940年代',
  '1950年代',
  '1960年代',
  '1970年代',
  '1980年代',
  '1990年代',
  '3D',
  'アブストラクトフラワー',
  'アフリカン',
  'リンゴ',
  'アクア',
  '建築',
  'アート',
  'アールヌーボー',
  'アーティスティック',
  'アーツ・アンド・クラフツ',
  '秋',
  '秋冬',
  'アズテック',
  '竹',
  'バナナ',
  'バンダナ',
  'バロック',
  'バティック',
  'バウハウス',
  'ビートル',
  'ビッグフラワー',
  '鳥',
  'ブラック',
  '白黒',
  'ブルーム',
  'ブロッサム',
  'ブルー',
  '青と白',
  'ブラー',
  'ボート',
  '大胆',
  'ボタニカル',
  'ブーケ',
  'ブライト',
  'ブラウン',
  'ブラシストローク',
  '蝶',
  'サボテン',
  'キャンディ',
  '車',
  'カートゥーン',
  '猫',
  'チェーン',
  'チェリー',
  'シェブロン',
  'シノワズリ',
  'クリスマス',
  'サークル',
  '雲',
  'コラージュ',
  'カラフル',
  'コンテンポラリー',
  'コーラル',
  'クリーム',
  'キュート',
  'シアン',
  '水仙',
  'デイジー',
  'ダマスク',
  'ダーク',
  'ダークブルー',
  'ダークグリーン',
  'デコラティブ',
  'ディテール',
  'ダイヤモンド',
  'デジタル',
  'ディストーション',
  '小花柄',
  '犬',
  'イルカ',
  'ドゥードゥル',
  'ドット',
  'ドリンク',
  '象',
  '刺繍',
  'エキゾチック',
  'フェード',
  '秋',
  '秋冬',
  '羽',
  'シダ',
  '魚',
  'フラミンゴ',
  'フローリッシュ',
  'フォリッジ',
  'フォーク',
  'フォークロア',
  'フード',
  '森',
  'フーラード',
  'カエル',
  'フルーツ',
  'フューシャ',
  'ファン',
  'フューチャリスティック',
  'ギャラクシー',
  'ギンガム',
  'キリン',
  'ガールズ',
  'ゴールド',
  'ゴシック',
  'グラフィティ',
  'グラフィック',
  'グラフィックフローラル',
  'グラフィックパターン',
  'グリーン',
  'グレー',
  'グランジ',
  'ハロウィン',
  '手描き',
  'ハワイアン',
  'ハート',
  'ヘリンボーン',
  'ハイビスカス',
  '真夏',
  'ホリデー',
  '馬',
  'ハウンドトゥース',
  'アイスクリーム',
  'イカット',
  'イラスト',
  '印象派',
  'インディアン',
  'インディゴ',
  'インク',
  '昆虫',
  '玉虫色',
  'アヤメ',
  'ジャカード',
  '和風',
  'ジュエル',
  'ジャングル',
  'カレイドスコープ',
  '着物',
  'ニット',
  'レース',
  '風景',
  'ラージスケール',
  'ラベンダー',
  'レイヤード',
  'リーフ',
  'レモン',
  'レオパード',
  'レター',
  'ライト',
  'ライラック',
  'ユリ',
  'リニア',
  'ライン',
  'マゼンタ',
  'モクレン',
  'マンダラ',
  'マーブル',
  '牧草地',
  'メキシカン',
  'ミニマル',
  'ミラー',
  'ミクストメディア',
  'モダン',
  'モダニズム',
  'モノクロ',
  'モロッカン',
  'モザイク',
  '蛾',
  'モチーフ',
  'マルチカラー',
  'ナイーブ',
  'ノーティカル',
  'ネイビー',
  'ネオン',
  '北欧風',
  '数字',
  'オーシャン',
  'オンブレ',
  'オプティカル',
  'オレンジ',
  '蘭',
  'オリエンタル',
  'オーナメンタル',
  'ペイント',
  'ペイズリー',
  'パーム',
  'パンジー',
  'オウム',
  'パステル',
  'パッチワーク',
  '牡丹',
  'ピープル',
  '花びら',
  'フォトグラフィック',
  'パイナップル',
  'ピンク',
  'ピクセル',
  '植物',
  'プレイフル',
  'ポピー',
  'プリティ',
  'サイケデリック',
  'パンク',
  'パープル',
  'ウサギ',
  'レッド',
  'リゾート',
  'レトロ',
  'ロマンチック',
  'ローズ',
  'スカーフ',
  'スクリブル',
  'シェイプ',
  '絞り染め',
  'シルエット',
  'シルバー',
  'シンプル',
  'スケッチ',
  'スカル',
  'スモールスケール',
  'スネーク',
  '宇宙',
  'スペーシング',
  'スポット',
  '春',
  '春夏',
  'スクエア',
  'ヒトデ',
  'スター',
  'ステンシル',
  'イチゴ',
  'ストリートアート',
  '夏',
  '夏祭り',
  'スイーツ',
  'スワール',
  'シンメトリー',
  'タータン',
  'ティール',
  'タイダイ',
  'タイガー',
  'トーナル',
  '木',
  'トライアングル',
  'チューリップ',
  'ターコイズ',
  'バレンタイン',
  'ベクターパターン',
  '野菜',
  'ビビッド',
  'ヴィンテージ',
  'バイオレット',
  '壁紙',
  '水彩',
  'ウェーブ',
  '織り',
  'クジラ',
  'ホワイト',
  'ワイルドフラワー',
  '冬',
  '包装紙',
  'イエロー',
  'ゼブラ',
  'ジグザグ',
];
